import { FagmoblerAlgoliaProduct } from '@fagmobler/types';
import { ReactNode } from 'react';
import { ArrowRightIcon } from '@heroicons/react/20/solid';
import type { OmniumStore } from '@fagmobler/omnium';
import { twMerge } from 'tailwind-merge';
import clsx from 'clsx';

export type ProductCollectionCardProps = {
  className?: string;
  classNameTitle?: string;
  title?: string;
  subtitle?: string;
  size?: 'sm' | 'md' | 'lg';
  renderImage?(product: FagmoblerAlgoliaProduct): ReactNode;
  href?: string;
  readMoreText?: string;
  store?: OmniumStore;
  children?: ReactNode;
};

export const ProductCollectionCard = (props: ProductCollectionCardProps) => {
  const {
    title,
    subtitle,
    href,
    readMoreText = 'Se alle produkter',
    className,
    classNameTitle,
    children,
  } = props;

  return (
    <article className={className}>
      <div className="flex justify-between flex-col md:flex-row">
        <div className="mb-2">
          <h2 className={twMerge(clsx('hd-xl', classNameTitle))}>{title}</h2>
          <div className="body-base">{subtitle}</div>
        </div>
        {href && (
          <a
            className="underline underline-offset-2 flex items-center"
            href={href}
          >
            {readMoreText} <ArrowRightIcon className="h-5 ml-1" />
          </a>
        )}
      </div>

      <ul className="grid gap-4 grid-cols-2 sm:grid-cols-3 md:grid-cols-4 mt-2">
        {children}
      </ul>
    </article>
  );
};

export default ProductCollectionCard;
